import { Autocomplete, Stack, TextField, Typography } from '@mui/material'
import type { TemplateListItem } from '@ulysses-inc/harami_api_client'
import type React from 'react'
import FormikErrorMessage from 'src/components/formikErrorMessage/FormikErrorMessage'
import type { TBaseFormRowProps } from './EditSchedule'

const ScheduleTemplateRow: React.FC<
  TBaseFormRowProps<{
    templates: TemplateListItem[]
  }>
> = ({
  templates: existingTemplates,
  setFieldValue,
  values: { templates },
  errors,
  touched,
}) => {
  const selectedTemplate = existingTemplates.find(
    t => t.id === (templates ?? [])[0]?.id,
  )

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle1" fontWeight="bold">
        ひな形
      </Typography>
      {existingTemplates.length > 0 && (
        <Autocomplete<TemplateListItem, false, false, false>
          fullWidth
          options={existingTemplates}
          value={selectedTemplate || null}
          onChange={(_, newValue) => {
            if (newValue) {
              setFieldValue('templates', [{ id: newValue.id }])
            }
          }}
          getOptionKey={option => String(option.id)}
          getOptionLabel={option => option.name || ''}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderInput={params => (
            <TextField {...params} placeholder="ひな形を選択" size="small" />
          )}
        />
      )}

      <Stack>
        <FormikErrorMessage
          name="templates"
          errors={errors}
          touched={touched}
        />
      </Stack>
    </Stack>
  )
}

export default ScheduleTemplateRow
